'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _angular = require('angular');

var _angular2 = _interopRequireDefault(_angular);

var _angularUiRouter = require('angular-ui-router');

var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);

var _list = require('./list.component');

var _list2 = _interopRequireDefault(_list);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var floraModule = _angular2.default.module('list', [_angularUiRouter2.default]).config(function ($stateProvider) {
  "ngInject";

  $stateProvider.state('dashboard.list', {
    url: '/list/:modelEnum',
    component: 'resourceList',
    params: {
      modelEnum: null
    }
  });
}).component('resourceList', _list2.default).name;

exports.default = floraModule;


// WEBPACK FOOTER //
// ./client/app/components/dashboard/list/list.js